import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import ServerRouting from './ServerRouting';
import RouteTitle from '../../../../presentation/RouteTitle';

class ServerRoutingList extends React.Component {
  render(){
    return (
      <PageAuthorize groups={['Administrators','Operations']}>
        <RouteTitle title='Rate Call Server Routing' />
        <ServerRouting />
      </PageAuthorize>
    );
  }
}

export default ServerRoutingList;



// WEBPACK FOOTER //
// ./src/content/technical/serverrouting/components/ServerRoutingList.js